import Integration from "./layout/integration";
import SuperAdmin from "./layout/super-admin";
import { useAuthInfo } from "./context/auth";

const useRoutes = () => {
  const [authSession] = useAuthInfo();
  return [
    {
      key: "integrations",
      route: "/integrations/*",
      component: <Integration />,
    },
    {
      key: "app",
      route: "/admin/*",
      component: <SuperAdmin />,
      // guard: {
      //   valid: !authSession?.activeAccountId,
      //   redirect: `/account/${authSession?.companyId}/${authSession?.activeAccountId}/users`,
      // },
    },
  ];
};

export default useRoutes;
